import { Organization } from 'src/app/models/organization';

export class OrganizationActivationDialogData {
    /**
     *
     * @param organizations : Liste des organisations
     */
    public constructor(public organizations: Organization[] = null) {}

    // Organisation sélectionnée
    public selectedOrganization: Organization = null;
}
